import { render, staticRenderFns } from "./WebsiteArticleDetail.vue?vue&type=template&id=6924fac8&scoped=true&"
import script from "./WebsiteArticleDetail.vue?vue&type=script&lang=js&"
export * from "./WebsiteArticleDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6924fac8",
  null
  
)

export default component.exports